module.exports = __webpack_public_path__ + "img/adigun.1beed1be.jpg";